<template>
  <!--//@*/*
      //    *RPD  App v0.91
      //    * Copyright (c) 2022, Blue Cover Six LLC .John Molt All rights reserved.
      //    Code licensed under contract To Reno Police Department / City of Reno, in perpetuity
      //    */
      //-->
  <v-expansion-panel popout class="mt-2" width="100%">
    <v-expansion-panel-header color="#708e92" class="white--text">
      <template v-slot:actions>
        <v-icon color="white"> $expand </v-icon>
      </template>
      I have new information/photographs to add to my report. How do I add it to
      my report?
    </v-expansion-panel-header>
    <v-expansion-panel-content class="grey lighten-5">
      <v-row>
        <c-col id="faq-content">
          <v-card elevation="2" tile class="mt-8 mb-4">
            <v-card-text class="black--text">
              The easiest way to add photographs or new information to your
              report is to file a supplemental online report. On the
              <a
                href="https://renopd.com/report"
                target="_blank"
                title="Reno Police Department File a Report"
                >File a Report</a
              >
              page, there is an option to “Add to Report” in English or Spanish
              where additional information can be collected. Please write out
              the additional information or that you have photographs (video,
              screenshots, PDFs, etc.) that you would like to add and a Police
              Services Specialist will issue you a link from Axon/Evidence.com.
              The link works like any other upload software and will last for 10
              (ten) days before expiring. Axon is the same platform provider
              that Reno Police Department officers use to store body worn camera
              footage and digital evidence. Twenty-five items can be uploaded at
              a time using the link. If you have any issues or questions
              regarding supplemental reports, please contact the Reno Police
              Department Front Desk at
              <a href="tel:+17753342175">775-334-2175</a>.
            </v-card-text>
          </v-card>
        </c-col>
      </v-row>
    </v-expansion-panel-content>
  </v-expansion-panel>
</template>
<style scoped>
.bcs-expansion-content {
  color: black;
}
.howwrap {
  word-break: break-word;
}
</style>
<script>
import { bus_common } from "../mixins/bus_common";
export default {
  name: "fd_faq_new_info",
  mixins: [bus_common],
  data: function () {
    return {};
  },
  watch: {},
  computed: {},
  methods: {
    init: function () {
      this.show_loader(false);
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.init();
      // The whole view is rendered, so I can safely access or query
      // the DOM. ¯\_(ツ)_/¯
    });
  },
};
</script>
